<template>
    <button :disabled="loading" class="btn" :class="{ disabled: loading }" @click="$emit('click')">
        <span v-show="!loading">
            <slot />
        </span>
        <span v-show="loading"><i class="fa fa-spinner fa-spin" /> {{ progressText }}</span>
    </button>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        progressText: {
            type: String,
            default: 'Please wait...'
        }
    }
};
</script>
